import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DICTIONARY_REQUEST_TYPES, REQUEST_DETAIL_CATEGORY } from 'src/app/extensions/constants/commonConstants';
import { TranslateService } from '@ngx-translate/core';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { RequestAPIService } from 'src/app/extensions/services/api/request-api.service';
import { ClientDataRequestTypeEnum } from 'src/app/models/ClientDataEnums';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { ClientDataRequestEvents } from 'src/app/extensions/services/api/events';

@Component({
  selector: 'client-data-details-view',
  templateUrl: './client-data-details.component.html',
  styleUrls: ['./client-data-details.component.scss'],
  standalone: false,
})
export class ClientDataRequestDetailsComponent implements OnInit {
  isDataLoaded: boolean = false;
  public typesEnum = ClientDataRequestTypeEnum;
  public clientDataRequest: app.models.GetClientDataRequest = {} as app.models.GetClientDataRequest;

  REQUEST_DETAIL_CATEGORY = REQUEST_DETAIL_CATEGORY;
  DICTIONARY_REQUEST_TYPES = DICTIONARY_REQUEST_TYPES;
  selectedCategory: string = REQUEST_DETAIL_CATEGORY.INFO;
  isAdmin: boolean = false;
  clientDataRequestChangeStatusModel: app.models.ClientDataRequestChangeStatusModel =
    {} as app.models.ClientDataRequestChangeStatusModel;
  public fillModeNone: DateInputFillMode = 'none';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';
  statuses: app.models.DictionaryDataModel[];
  public statusId: string = '';
  public dictionaryRequestStatus = DictionaryRequestStatus;

  constructor(
    private _location: Location,
    private _activatedRoute: ActivatedRoute,
    private _requestService: RequestAPIService,
    private _globalService: GlobalService,
    private _dictionaryAPIService: DictionaryAPIService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.isAdmin = this._globalService.isAdminUser();
    this.clientDataRequest.clientDataRequestId = this._activatedRoute.snapshot.params['id'];
    this._requestService
      .getClientDataRequest(this.clientDataRequest.clientDataRequestId)
      .subscribe(clientDataResult => {
        if (clientDataResult.data) {
          this.clientDataRequest = clientDataResult.data;

          if (
            this.clientDataRequest.dictionaryClientDataRequestType.code === this.typesEnum.BankAccount &&
            this.clientDataRequest.otherObservations
          ) {
            const parts = this.clientDataRequest.otherObservations.split(';', 2);
            this.clientDataRequest.iban = parts.length > 0 ? parts[0] : '-';
            this.clientDataRequest.bank = parts.length > 1 ? parts[1] : '-';
          }
        }
        this.statusId = this.clientDataRequest.dictionaryRequestStatus.id.toLowerCase();
        if (this._activatedRoute.snapshot.queryParams['openTab']) {
          this.selectedCategory = this._activatedRoute.snapshot.queryParams['openTab'];
        }
        this.loadData();
        this.isDataLoaded = true;
      });
  }

  redirectListHandler() {
    this._location.back();
  }

  categoryChangeHandler(selectedCategory: string) {
    this.selectedCategory = selectedCategory;
  }

  loadData() {
    this._dictionaryAPIService.getDictionaryRequestStatuses().subscribe(statusResult => {
      if (statusResult.data) {
        this.statuses = statusResult.data.map(x => ({ ...x, id: x.id.toLowerCase() }));
      }
    });
  }

  changeClientDataRequestStatus(statusId: string) {
    const initialStatus = this.clientDataRequest.dictionaryRequestStatus;
    let statusCode = this.statuses.find(x => x.id == statusId).code;
    this.clientDataRequestChangeStatusModel.requestId = this.clientDataRequest.clientDataRequestId;
    this.clientDataRequestChangeStatusModel.dictionaryRequestStatusCode = statusCode;
    this._requestService.changeClientDataRequestStatus(this.clientDataRequestChangeStatusModel).subscribe(result => {
      if (result.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('request.statusChange.notifications.requestStatusChanged'),
          this._translateService.instant('common.success')
        );
        let currentStatus = this.statuses.find(
          x =>
            x.id ===
            result.response.events.find(y => y.eventType === ClientDataRequestEvents.ClientDataRequestStatusChanged)
              .eventBody?.dictionaryRequestStatusId
        );

        this.clientDataRequest.dictionaryRequestStatus = currentStatus;
      } else {
        this._notificationService.showError(
          this._translateService.instant('request.statusChange.notifications.requestStatusChangeFailed'),
          this._translateService.instant('common.error')
        );
        this.clientDataRequest.dictionaryRequestStatus = initialStatus;
      }
    });
  }
}
